import { render } from "./HomeAbout.vue?vue&type=template&id=36902ce8&scoped=true&ts=true"
import script from "./HomeAbout.vue?vue&type=script&lang=ts"
export * from "./HomeAbout.vue?vue&type=script&lang=ts"

import "./HomeAbout.vue?vue&type=style&index=0&id=36902ce8&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36902ce8"]])

export default __exports__